import { useCallback } from 'react';

import type { MouseTouchEvent } from '../tracking/types';
import type { PreventDefaultLinkOut } from './types';
import { PreventDefaultLinkOutAttribute } from './useDefaultLinkout';

export function usePreventDefaultLinkOut(): PreventDefaultLinkOut {
  const allowDefaultLinkOut = useCallback((target: HTMLElement) => {
    target.removeAttribute(PreventDefaultLinkOutAttribute);
  }, []);

  const preventDefaultLinkOut = useCallback((target: HTMLElement) => {
    target.setAttribute(PreventDefaultLinkOutAttribute, 'true');
  }, []);

  const preventDefaultLinkOutOn = useCallback(
    (e: MouseTouchEvent) => {
      preventDefaultLinkOut(e.target as unknown as HTMLElement);
    },
    [preventDefaultLinkOut],
  );

  return {
    preventDefaultLinkOutOn,
    preventDefaultLinkOut,
    allowDefaultLinkOut,
  };
}
